import React, {useContext} from "react";

export type StitchInverseStyleProps = {
  children?: React.ReactNode;
  invert?: boolean;
};

const InverseStyleContext = React.createContext<StitchInverseStyleProps>({
  invert: false,
});

export const useInverseStyleContext = () => useContext(InverseStyleContext);

export const StitchInverseStyleProvider = (props: StitchInverseStyleProps) => {
  const {children, invert} = props;
  return (
    <InverseStyleContext.Provider value={{invert: invert ?? true}}>
      {children}
    </InverseStyleContext.Provider>
  );
};
